<div class="w-full section-wrapper">
  <div class="section-title font-poppins font-bold">
    {{section.title}}
  </div>
  <div>
    <hr class="section-separation w-full h-[0.1rem]">
  </div>
  <div class="content-wrapper">
    <app-resource-content [content]="section.content"></app-resource-content>
  </div>
</div>
